import { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { baseColors, BaseStack } from "goi_common/src/design-system";
import { HEADER_HEIGHT, SECOND_HEADER_HEIGHT } from "@/constants/components";

const BANNER_TOP_MOBILE = HEADER_HEIGHT + SECOND_HEADER_HEIGHT + 16;
const BANNER_TOP_DESKTOP = HEADER_HEIGHT + 16;
const PC_BREAKPOINT = 1024;

interface Props {
  remainingMs: number;
}

export function FomoCountdownBanner({ remainingMs }: Props) {
  const minutes = String(Math.floor(remainingMs / 60000)).padStart(2, "0");
  const seconds = String(Math.floor((remainingMs / 1000) % 60)).padStart(
    2,
    "0"
  );

  const [bannerTop, setBannerTop] = useState(BANNER_TOP_MOBILE);

  useEffect(() => {
    const isPC = () => window.innerWidth >= PC_BREAKPOINT;

    const updateBannerTop = () => {
      setBannerTop(isPC() ? BANNER_TOP_DESKTOP : BANNER_TOP_MOBILE);
    };

    updateBannerTop();
    window.addEventListener("resize", updateBannerTop, { passive: true });
    return () => {
      window.removeEventListener("resize", updateBannerTop);
    };
  }, []);

  return (
    <Box
      position="fixed"
      top={`${bannerTop}px`}
      left="50%"
      transform="translateX(-50%)"
      width="calc(100% - 32px)"
      maxWidth="440px"
      zIndex={1000}
      background={baseColors.label_normal}
      borderRadius="12px"
      px="16px"
      py="10px"
    >
      <BaseStack
        direction="horizontal"
        spacing={16}
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <BaseStack spacing={2}>
          <Box
            className="headline_2_sb"
            color={baseColors.red_300}
            whiteSpace="nowrap"
          >
            10만원 추가 할인
          </Box>
          <Box
            className="headline_2_sb"
            color={baseColors.white}
            whiteSpace="nowrap"
          >
            이벤트 마감까지
          </Box>
        </BaseStack>

        <BaseStack direction="horizontal" spacing={4} alignItems="flex-start">
          <BaseStack spacing={4} alignItems="center">
            <Box
              background={baseColors.red_150}
              borderRadius="6px"
              px="6px"
              py="6px"
              minWidth="44px"
              textAlign="center"
              className="title_3_b"
              color={baseColors.status_negative}
            >
              {minutes}
            </Box>
            <Box className="caption_2_sb" color={baseColors.label_muted_1}>
              분
            </Box>
          </BaseStack>

          <Box className="title_3_b" color="white" pt="6px">
            :
          </Box>

          <BaseStack spacing={4} alignItems="center">
            <Box
              background={baseColors.red_150}
              borderRadius="6px"
              px="6px"
              py="6px"
              minWidth="44px"
              textAlign="center"
              className="title_3_b"
              color={baseColors.status_negative}
            >
              {seconds}
            </Box>
            <Box className="caption_2_sb" color={baseColors.label_muted_1}>
              초
            </Box>
          </BaseStack>
        </BaseStack>
      </BaseStack>
    </Box>
  );
}
